import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useMemo, useState } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';

function SignUp_3({ item }) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  const generalStyle = useSelector(state => state.themeSlice?.branding?.generalStyle);
  const sixthThemeColor = generalStyle?.sixthThemeColor ?? 'black';
  const iconFilter = useMemo(() => HexToHueConverter(sixthThemeColor), []);

  return (
    <div className="h-full w-full overflow-hidden pointer-events-auto">
      <div className="overflow-auto" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems:
              customization?.textAlignment === 'center'
                ? 'center'
                : customization?.textAlignment === 'right'
                ? 'flex-end'
                : 'flex-start',
            textAlign: customization?.textAlignment,
            paddingTop: staticValues[30],
            paddingLeft: staticValues[10],
            paddingRight: staticValues[10],
            paddingBottom: staticValues[10],
          }}
        >
          <div
            style={{
              fontSize: customization?.textSize,
              fontWeight: customization?.textWeight,
              color: customization?.textColor,
            }}
          >
            {item?.data?.text || 'Hesabını Oluştur'}
          </div>
          <div
            style={{
              fontSize: staticValues[12],
              color: 'var(--secondaryThemeColor)',
            }}
          >
            {item?.data?.description || 'Devam etmek için bir hesap oluşturun!'}
          </div>
        </div>
        <div
          className="form"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 15,
            padding: staticValues[10],
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              width: 'max-content',
              width: '100%',
              borderRadius: 10,
              fontSize: staticValues[12],
            }}
          >
            <div style={{ flex: 1 }}>
              <input
                type="text"
                required
                style={{
                  paddingTop: staticValues[10],
                  paddingRight: staticValues[10],
                  paddingBottom: staticValues[10],
                  paddingLeft: 0,
                  width: '100%',
                  color: 'black',
                  padding: staticValues[10],
                  borderRadius: 10,
                  fontSize: staticValues[12],
                  backgroundColor: 'var(--fifthThemeColor)',
                }}
                placeholder="Lütfen İsiminizi Girin"
              />
            </div>

            <label
              htmlFor="myInput"
              style={{
                position: 'absolute',
                top: '-10px',
                left: '20px',
                padding: '0 5px',
                fontSize: staticValues[12],
                fontWeight: 600,
                backgroundColor: 'var(--primaryThemeColor)',
                color: 'var(--secondaryThemeColor)',
                borderRadius: 5,
              }}
            >
              İsim
            </label>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              width: 'max-content',
              width: '100%',
              borderRadius: 10,
              fontSize: staticValues[12],
            }}
          >
            <div style={{ flex: 1 }}>
              <input
                type="text"
                required
                style={{
                  paddingTop: staticValues[10],
                  paddingRight: staticValues[10],
                  paddingBottom: staticValues[10],
                  paddingLeft: 0,
                  width: '100%',
                  color: 'black',
                  padding: staticValues[10],
                  borderRadius: 10,
                  fontSize: staticValues[12],
                  backgroundColor: 'var(--fifthThemeColor)',
                }}
                placeholder="Lütfen Soy İsiminizi Girin"
              />
            </div>

            <label
              htmlFor="myInput"
              style={{
                position: 'absolute',
                top: '-10px',
                left: '20px',
                padding: '0 5px',
                fontSize: staticValues[12],
                fontWeight: 600,
                backgroundColor: 'var(--primaryThemeColor)',
                color: 'var(--secondaryThemeColor)',
                borderRadius: 5,
              }}
            >
              Soy isim
            </label>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              width: 'max-content',
              width: '100%',
              borderRadius: 10,
              fontSize: staticValues[12],
            }}
          >
            <div style={{ flex: 1 }}>
              <input
                type="text"
                required
                style={{
                  paddingTop: staticValues[10],
                  paddingRight: staticValues[10],
                  paddingBottom: staticValues[10],
                  paddingLeft: 0,
                  width: '100%',
                  color: 'black',
                  padding: staticValues[10],
                  borderRadius: 10,
                  fontSize: staticValues[12],
                  backgroundColor: 'var(--fifthThemeColor)',
                }}
                placeholder="Lütfen Mailinizi Girin"
              />
            </div>

            <label
              htmlFor="myInput"
              style={{
                position: 'absolute',
                top: '-10px',
                left: '20px',

                padding: '0 5px',

                fontSize: staticValues[12],
                backgroundColor: 'var(--primaryThemeColor)',
                color: 'var(--secondaryThemeColor)',
                borderRadius: 5,
                fontWeight: 600,
              }}
            >
              Email
            </label>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              width: 'max-content',
              width: '99%',
              borderRadius: 10,
              fontSize: staticValues[12],
              backgroundColor: 'var(--fifthThemeColor)',
            }}
          >
            <div style={{ flex: 1 }}>
              <input
                type="text"
                required
                style={{
                  paddingTop: staticValues[10],
                  paddingRight: staticValues[10],
                  paddingBottom: staticValues[10],
                  paddingLeft: 0,
                  width: '99%',
                  color: 'black',
                  padding: staticValues[10],
                  borderRadius: 10,
                  fontSize: staticValues[12],
                  backgroundColor: 'var(--fifthThemeColor)',
                }}
                placeholder="Lütfen Şifrenizi Girin"
              />
            </div>
            <div
              className="cursor-pointer z-5 !pointer-events-auto"
              onClick={() => {
                setIsPasswordVisible(state => !state);
              }}
              style={{ padding: staticValues[10] }}
            >
              <img
                style={{
                  filter: iconFilter,
                }}
                width={20}
                height={20}
                src={isPasswordVisible ? customization?.passwordOpenIcon : customization?.passwordCloseIcon}
              />
            </div>
            <label
              htmlFor="myInput"
              style={{
                position: 'absolute',
                top: '-10px',
                left: '20px',

                padding: '0 5px',

                fontSize: staticValues[12],
                backgroundColor: 'var(--primaryThemeColor)',
                color: 'var(--secondaryThemeColor)',
                borderRadius: 5,
                fontWeight: 600,
              }}
            >
              Şifre
            </label>
          </div>

          <div
            style={{
              backgroundColor: customization?.buttonColor,
              color: customization?.buttonTextColor,
              borderRadius: 10,
              padding: staticValues[10],
              fontSize: staticValues[14],
            }}
          >
            Kayıt Ol
          </div>

          <div
            style={{
              fontSize: staticValues?.[10],
              fontWeight: 500,
              color: 'var(--secondaryThemeColor)',
            }}
          >
            Devam ederek,
            <span style={{ color: customization?.accentColor }}> Gizlilik Politikasını</span> kabul etmiş olursunuz.
          </div>
        </div>
        <div
          style={{
            marginTop: staticValues[10],
            fontSize: staticValues[14],
            color: 'var(--secondaryThemeColor)',
            fontWeight: 500,
          }}
        >
          Hesabınız var mı?
          <span
            style={{
              fontWeight: 500,
              color: customization?.accentColor,
              marginLeft: staticValues[5],
            }}
          >
            Giriş Yap
          </span>
        </div>
      </div>
    </div>
  );
}

export default SignUp_3;
